import { render, staticRenderFns } from "./AfterService.vue?vue&type=template&id=5508abb0&scoped=true&"
import script from "./AfterService.vue?vue&type=script&lang=js&"
export * from "./AfterService.vue?vue&type=script&lang=js&"
import style0 from "./AfterService.vue?vue&type=style&index=0&id=5508abb0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5508abb0",
  null
  
)

export default component.exports